<template>
  <b-container>
    <b-row align-h="center" class="mt-5">
      <b-col cols="5">
        <b-card class="p-3">
          <h3 class="mb-4">Login</h3>
          <b-form @submit.prevent="onSubmit">
            <b-form-group
              id="exampleInputGroup1"
              label="Email address:"
              label-for="exampleInput1"
            >
              <b-form-input
                id="exampleInput1"
                type="email"
                v-model="form.email"
                required
                placeholder="Email"
              >
              </b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              label="Password:"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="password"
                v-model="form.password"
                required
                placeholder="Password"
              >
              </b-form-input>
            </b-form-group>
            <div>
              <b-button block type="submit" variant="primary">Submit</b-button
              >&nbsp;
            </div>
             <div class="mt-5 d-flex justify-content-center" v-if="isLoading">
                <b-spinner variant="success"></b-spinner>
              </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      isLoading: false
    };
  },
  methods: {
    onSubmit() {
      this.isLoading = true
      fetch(process.env.VUE_APP_API_BASE_URL + "/api/v1/adminUsers/loginToBack", {
        method: "POST",
        body: JSON.stringify(this.form),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res)=>res.json())
        .then((data) => {
          if (data.status === "success") {
            localStorage.user = data.user.email.split('@')[0];
            this.localStorage.token = data.token;
            this.$emit('token', data.token)         
          }
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false

        });
    },
  },
};
</script>

<style></style>
